import { CpfCnpjPipe } from './../../shared/cpf-cnpj.pipe';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import * as moment from 'moment';

import { ListItem } from './../../shared/list-confirmation/model/list-item';
import { ESituacaoTransferenciaAutorizacao, Transaction } from './models/transaction';
import { FormatPricePipe } from '../../shared/format-price.pipe';
import { endpoints } from '../../../environments/environment';
import { AccountNumberPipe } from '../../shared/account-number.pipe';
import { Util } from '../../utils/util';

@Injectable()
export class TransactionHistoryService {

	private dateBegin: any = moment(new Date()).subtract(15, 'days').format('YYYY-MM-DD');
	private dateEnd: any = moment(new Date()).add(365, 'days').format('YYYY-MM-DD');

	constructor(private http: HttpClient) { }

	getDetailsPackages(transaction: Transaction): Observable<any> {
		const FP = new FormatPricePipe();

		return this.http.get(endpoints.transactions.detailPackages + transaction.code).pipe(map((data: any) => {
			transaction.details = [];
			transaction.details.push(new ListItem('Pacote:', data.Retorno.NmPacote));
			transaction.details.push(new ListItem('Valor do pacote:', FP.transform(data.Retorno.VlrPacote, false) + '/ mês'));

			return transaction.details;
		}));
	}

	getTransactions(type: string): Observable<any> {

		const params = new HttpParams()
			.set('dataInicial', this.dateBegin)
			.set('status', type);
			// .set('dataFinal', this.dateEnd)

		return this.http.get(endpoints.transactions.all, { params }).pipe(map((data: any) => {

			const pendingList = data.Retorno.map(item => {
				const transactionPending = new Transaction();
				transactionPending.useNewLimit = item.UtilizaNovoLimite;
				transactionPending.code = item.Numero;
				transactionPending.date = moment(item.DataHoraSolicitacao).format('DD/MM/YYYY');
				transactionPending.hour = moment(item.DataHoraSolicitacao).format('HH:mm');
				const FP = new FormatPricePipe();
				transactionPending.value = FP.transform(item.Valor, false);

				transactionPending.Authorizers = [];

				if(item.Autorizadores){
					item.Autorizadores.forEach(autorizador => {
						transactionPending.Authorizers.push(autorizador);
					});
				}

				if(item.Favorecido !== undefined){
					transactionPending.favored = item.Favorecido;
				}

				transactionPending.requester = item.NomeSolicitante;
				transactionPending.situation = item.Situacao;
				transactionPending.typeTransaction = item.TipoTransacao;
				if (item.TipoTransacao === 'EntreContas') {
					transactionPending.typeTransactionLabel = 'Entre Contas';
				} else if (item.TipoTransacao === 'PIX') {
					transactionPending.typeTransactionLabel = 'Pagamento Pix';
				} else if (item.TipoTransacao === 'PIXDevolvido') {
					transactionPending.typeTransactionLabel = 'Devolução Pix';
				} else {
					transactionPending.typeTransactionLabel = item.TipoTransacao;
				}

				transactionPending.debitDate = moment(item.Data).format('DD/MM/YYYY');

				if(transactionPending.useNewLimit){
					transactionPending.details  = this.extractDetails(item);
				}

				if(transactionPending.useNewLimit && transactionPending.Authorizers){
					transactionPending.details = transactionPending.details.concat(this.extractAuthorizers(transactionPending));
				}

				switch (item.Situacao) {
					case 'pendenteAprovacao':
						transactionPending.situationLabel = 'Pendente de Aprovação';
						break;
					case 'aprovadaAgendada':
						transactionPending.situationLabel = 'Agendada';
						break;
					case 'efetivada':
						transactionPending.situationLabel = 'Efetivada';
						break;
					case 'naoRealizada':
						transactionPending.situationLabel = 'Não realizada';
						break;
					case 'reprovada':
						transactionPending.situationLabel = 'Reprovada';
						break;
					case 'expirada':
						transactionPending.situationLabel = 'Expirada';
						break;
					case 'erroProcessamento':
						transactionPending.situationLabel = 'Erro no curso do processamento';
						break;
					case 'autorizadaPendenteAprovacao':
						transactionPending.situationLabel = 'Autorizada e pendente de demais aprovações';
						break;
					case 'pixEnviadoAguardandoIF':
						transactionPending.situationLabel = 'Enviado e aguardando IF Destino';
						break;
					case 'pixReprovadoIF':
						transactionPending.situationLabel = 'Reprovado por outra IF';
						break;
					case 'canceladaTesouraria':
						transactionPending.situationLabel = 'Cancelada pela Tesouraria';
						break;
					case 'canceladaCliente':
						transactionPending.situationLabel = 'Cancelada pelo cliente';
						break;
				}



				return transactionPending;
			});

			return pendingList;

		}));


	}
	private extractAuthorizers(transactionPending: Transaction) : Array<ListItem> {
		const details : Array<ListItem> = [];

		transactionPending.Authorizers.forEach((element, index) => {
			if (element.NomeAutorizador && element.SituacaoAutorizacao === ESituacaoTransferenciaAutorizacao.aprovado) {
				if (index === 0) {
					details.push(new ListItem('Aprovado por:', `${element.NomeAutorizador}:  ${moment(element.DataHoraSituacao).format('DD/MM/YYYY hh:mm')}`, 'cls_mask'));
					return;
				} else {
					details.push(new ListItem('', `${element.NomeAutorizador}: ${moment(element.DataHoraSituacao).format('DD/MM/YYYY hh:mm')}`, 'cls_mask'));
				}
			}
		});

		return details;
	}

	extractDetails(item: any) : Array<ListItem> {
		const details : Array<ListItem> = [];
		const accNumPipe = new AccountNumberPipe();

			if(item.DebitoTED){
				details.push(new ListItem('Banco:', item.DebitoTED.NomeISPB, 'cls_mask'));
				details.push(new ListItem('Agência:', item.DebitoTED.CodigoAgencia, 'cls_mask'));
				details.push(new ListItem('Conta:', accNumPipe.transform(item.DebitoTED.NumeroConta), 'cls_mask'));
				if (item.DebitoTED.FavorecidoTipoConta === 'CC') {
					details.push(new ListItem('Tipo:', 'Conta Corrente'));
				} else if (item.DebitoTED.FavorecidoTipoConta === 'PP') {
					details.push(new ListItem('Tipo:', 'Conta Poupança'));
				} else if (item.DebitoTED.FavorecidoTipoConta === 'PG') {
					details.push(new ListItem('Tipo:', 'Conta Pagamento'));
				}
			}

			if(item.CreditoTED){
				details.push(new ListItem('Banco:', item.CreditoTED.NomeISPB, 'cls_mask'));
				details.push(new ListItem('Agência:', item.CreditoTED.CodigoAgencia, 'cls_mask'));
				details.push(new ListItem('Conta:', accNumPipe.transform(item.CreditoTED.NumeroConta), 'cls_mask'));
			}

			if(item.DebitoPIX){
				details.push(new ListItem('Banco:', item.DebitoPIX.RecebedorNmISPB, 'cls_mask'));
				details.push(new ListItem('Agência:', item.DebitoPIX.RecebedorAgencia, 'cls_mask'));
				details.push(new ListItem('Conta:', accNumPipe.transform(item.DebitoPIX.RecebedorNroConta), 'cls_mask'));
				details.push(new ListItem('Documento:', Util.maskCpfCnpjPix(item.DebitoPIX.RecebedorCPFCNPJ), 'cls_mask'));
				if (item.DebitoPIX.ChaveRecebedor) {
					details.push(new ListItem('Chave Pix:', this.formatKey(item.DebitoPIX.ChaveRecebedor), 'cls_mask'));
				}
				if (item.DebitoPIX.Historico) {
					details.push(new ListItem('Histórico:', item.DebitoPIX.Historico, 'cls_mask'));
				}
			}

			if(item.DebitoPIXDev){
				details.push(new ListItem('Banco:', item.DebitoPIXDev.RecebedorNmISPB, 'cls_mask'));
				details.push(new ListItem('Agência:', item.DebitoPIXDev.RecebedorAgencia, 'cls_mask'));
				details.push(new ListItem('Conta:', accNumPipe.transform(item.DebitoPIXDev.RecebedorNroConta), 'cls_mask'));
				details.push(new ListItem('Documento:', Util.maskCpfCnpjPix(item.DebitoPIXDev.RecebedorCPFCNPJ), 'cls_mask'));
				if (item.DebitoPIXDev.Historico) {
					details.push(new ListItem('Histórico:', item.DebitoPIXDev.Historico, 'cls_mask'));
				}
		}

		return details;
	}


	getDetails(transaction: Transaction): Observable<any> {

		return this.http.get(endpoints.transactions.detail + transaction.code).pipe(map((data: any) => {

			const CpfF = new CpfCnpjPipe();
			const accNumPipe = new AccountNumberPipe();
			transaction.details = [];

			switch (data.Retorno.TipoTransacao) {

				case 'EntreContas':
					transaction.details.push(new ListItem('Banco:', '613 - Omni Banco', 'cls_mask'));
					transaction.details.push(new ListItem('Conta:', accNumPipe.transform(data.Retorno.DetalheEntreContas.CodContaDestino), 'cls_mask'));

					break;

				case 'TED':
					transaction.details.push(new ListItem('Banco:', data.Retorno.DetalheTED.NomeBancoDestino, 'cls_mask'));
					transaction.details.push(new ListItem('Agência:', data.Retorno.DetalheTED.CodAgenciaDestino, 'cls_mask'));
					transaction.details.push(new ListItem('Conta:', accNumPipe.transform(data.Retorno.DetalheTED.CodContaDestino), 'cls_mask'));
					if (data.Retorno.DetalheTED.FavorecidoTipoConta === 'CC') {
						transaction.details.push(new ListItem('Tipo:', 'Conta Corrente'));
					} else if (data.Retorno.DetalheTED.FavorecidoTipoConta === 'PP') {
						transaction.details.push(new ListItem('Tipo:', 'Conta Poupança'));
					} else if (data.Retorno.DetalheTED.FavorecidoTipoConta === 'PG') {
						transaction.details.push(new ListItem('Tipo:', 'Conta Pagamento'));
					}
					break;

				case 'DOC':
					transaction.details.push(new ListItem('Banco:', data.Retorno.DetalheDOC.NomeBancoDestino));
					transaction.details.push(new ListItem('Agência:', data.Retorno.DetalheDOC.CodAgenciaDestino));
					transaction.details.push(new ListItem('Conta:', accNumPipe.transform(data.Retorno.DetalheDOC.CodContaDestino)));
					if (data.Retorno.DetalheDOC.FavorecidoTipoConta === 'CC') {
						transaction.details.push(new ListItem('Tipo:', 'Conta Corrente'));
					} else if (data.Retorno.DetalheDOC.FavorecidoTipoConta === 'PP') {
						transaction.details.push(new ListItem('Tipo:', 'Conta Poupança'));
					} else if (data.Retorno.DetalheDOC.FavorecidoTipoConta === 'PG') {
						transaction.details.push(new ListItem('Tipo:', 'Conta Pagamento'));
					}
					break;

				case 'Boleto':
					transaction.details.push(new ListItem('Código de barras:', data.Retorno.DetalheBoleto.CodBarras, 'cls_mask'));
					transaction.details.push(new ListItem('Vencimento:', moment(data.Retorno.DetalheBoleto.DataVencimento).format('DD/MM/YYYY')));
					break;

				case 'Convenio':
					transaction.details.push(new ListItem('Código de barras:', data.Retorno.DetalheConvenio.CodBarras, 'cls_mask'));
					break;

				case 'DARF':
					transaction.details.push(new ListItem('Data Referência:', moment(data.Retorno.DetalheDARF.DataReferencia).format('DD/MM/YYYY')));
					transaction.details.push(new ListItem('Data Vencimento:', moment(data.Retorno.DetalheDARF.DataVencimento).format('DD/MM/YYYY')));
					transaction.details.push(new ListItem('Receita:', data.Retorno.DetalheDARF.CodReceita, 'cls_mask'));
					transaction.details.push(new ListItem('Referência:', data.Retorno.DetalheDARF.NroReferencia, 'cls_mask'));
					const FP = new FormatPricePipe();
					transaction.details.push(new ListItem('Valor:', FP.transform(data.Retorno.DetalheDARF.ValorPrincipal, false), 'cls_mask'));
					transaction.details.push(new ListItem('Juros:', FP.transform(data.Retorno.DetalheDARF.ValorJuros, false), 'cls_mask'));
					transaction.details.push(new ListItem('Multa:', FP.transform(data.Retorno.DetalheDARF.ValorMulta, false), 'cls_mask'));
					transaction.details.push(new ListItem('Total:', FP.transform(data.Retorno.DetalheDARF.ValorTotal, false), 'cls_mask'));
					break;

				case 'GPS':
					transaction.details.push(new ListItem('Código do pagamento:', data.Retorno.DetalheGPS.CodPagamento, 'cls_mask'));
					transaction.details.push(new ListItem('Competência:', `
							${data.Retorno.DetalheGPS.MesCompetencia}/
							${data.Retorno.DetalheGPS.AnoCompetencia}
						`, 'cls_mask'));
					transaction.details.push(new ListItem('Tipo Identificador:', data.Retorno.DetalheGPS.TipoIdentificador, 'cls_mask'));
					transaction.details.push(new ListItem('Identificador:', data.Retorno.DetalheGPS.Identificador, 'cls_mask'));
					transaction.details.push(new ListItem('Nome Contribuinte:', data.Retorno.DetalheGPS.NomeContribuinte, 'cls_mask'));
					transaction.details.push(new ListItem('INSS:', data.Retorno.DetalheGPS.ValorINSS, 'cls_mask'));
					transaction.details.push(new ListItem('Outras Entidades:', data.Retorno.DetalheGPS.ValorOutrasEntidades, 'cls_mask'));
					transaction.details.push(new ListItem('Encargos:', data.Retorno.DetalheGPS.ValorEncargos, 'cls_mask'));
					transaction.details.push(new ListItem('Arrecadação:', data.Retorno.DetalheGPS.ValorArrecadacao, 'cls_mask'));
					break;

				case 'PIX':
					transaction.details.push(new ListItem('Banco:', data.Retorno.DetalhePIX.NomeBancoDestino, 'cls_mask'));
					transaction.details.push(new ListItem('Agência:', data.Retorno.DetalhePIX.CodAgenciaDestino, 'cls_mask'));
					transaction.details.push(new ListItem('Conta:', accNumPipe.transform(data.Retorno.DetalhePIX.CodContaDestino), 'cls_mask'));
					transaction.details.push(new ListItem('Documento:', Util.maskCpfCnpjPix(data.Retorno.DetalhePIX.CPFCNPJFavorecido), 'cls_mask'));
					if (data.Retorno.DetalhePIX.ChaveFavorecido) {
						transaction.details.push(new ListItem('Chave Pix:', this.formatKey(data.Retorno.DetalhePIX.ChaveFavorecido), 'cls_mask'));
					}
					if (data.Retorno.DetalhePIX.Historico) {
						transaction.details.push(new ListItem('Histórico:', data.Retorno.DetalhePIX.Historico, 'cls_mask'));
					}
					break;

				case 'PIXDevolvido':
					transaction.details.push(new ListItem('Banco:', data.Retorno.DetalheDevolucaoPIX.NomeBancoDestino, 'cls_mask'));
					transaction.details.push(new ListItem('Agência:', data.Retorno.DetalheDevolucaoPIX.CodAgenciaDestino, 'cls_mask'));
					transaction.details.push(new ListItem('Conta:', accNumPipe.transform(data.Retorno.DetalheDevolucaoPIX.CodContaDestino), 'cls_mask'));
					transaction.details.push(new ListItem('Documento:', Util.maskCpfCnpjPix(data.Retorno.DetalheDevolucaoPIX.CPFCNPJFavorecido), 'cls_mask'));
					if (data.Retorno.DetalheDevolucaoPIX.Historico) {
						transaction.details.push(new ListItem('Histórico:', data.Retorno.DetalheDevolucaoPIX.Historico, 'cls_mask'));
					}
					break;
			}

			return transaction.details;

		}));

	}

	private formatKey(key: string): string {
		if (key.startsWith('+')) {
				// phone
				return Util.formatPhone(key);
		} else if (key.length !== 36 && !key.includes('@')) {
				// CPF ou CNPJ (não é EVP e não é e-mail)
				return Util.maskCpfCnpj(key);
		}
		return key;
	}

	sendTransactionList(transactionList: Array<Transaction>): Observable<any> {
		return this.http.post(endpoints.transactions.processing, transactionList);
	}

	sendPackagesChanges(transaction: Transaction): Observable<any> {
		const sendList = [];

		if (transaction.statusCode === 1) {

		}
		return this.http.post(endpoints.transactions.processing , transaction);
	}

	/**
	 * Cria um novo array no formato pedido pelo servico a partir dos dados de transactionList
	 *
	 * @param transactionList Lista com as transacoes aprovadas, reprovadas e pendentes.
	 * @param statusCode Se for 3 significa que e pendente, entao nao deve ser enviada para o servico.
	 */
	sendChanges(transactionList: Array<Transaction>): Observable<any> {
		const sendList = [];
		let action;


		transactionList.map(item => {
			if (item.statusCode !== 4) {
				switch (item.statusCode) {
					case 1:
						action = 'aprovar';
						break;
					case 2:
						action = 'reprovar';
						break;
					case 3:
						action = 'cancelar';
						break;
				}
				sendList.push({
					'CodTransacao': item.code,
					'TipoTransacao': item.typeTransaction,
					'AcaoTransacao': action,
					'Motivo': item.statusCode === 2 ? item.reason : '',
					"UtilizaNovoLimite": item.useNewLimit,
					"CodigoRequisicao": Util.generateGUID(),
					"UtilizaNovaAprovacao": true,
				});
			}
		});

		return this.http.post( endpoints.transactions.processing , sendList);
	}

	passwordValidate(password: string): Observable<any> {
		const paymentData = {
			senha: password
		};

		return this.http.post(endpoints.accounts.validateTransactionPassword, paymentData);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transaction-history/transaction-history.service.ts